export default function ShareInformation({ className }) {
  return (
    <div className="mt-6">
      <p className={className}>To be updated later</p>
    </div>
  );
}
